import { render, staticRenderFns } from "./FacebookLogin.vue?vue&type=template&id=46127dd8&scoped=true&"
import script from "./FacebookLogin.vue?vue&type=script&lang=js&"
export * from "./FacebookLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46127dd8",
  null
  
)

export default component.exports